<script>
  import {
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Button
  } from 'element-ui'

  export default {
    name: 'CollapseButton',
    props: {
      max: {
        type: Number,
        default: 3
      }
    },
    render (h) {
      const buttons = this.getButtons(this.$slots.default)
      const outsideButtons = buttons.slice(0, this.max)
      const overflowButton = buttons.slice(this.max, buttons.length)

      return h('div', {
        class: 'pagoda-collapse-button'
      }, [
        ...outsideButtons,
        overflowButton.length ? h(Dropdown, {
          props: {
            placement: 'bottom'
          }
        }, [
          this.getCollapseControl(h),
          h(DropdownMenu, {
            slot: 'dropdown'
          }, overflowButton.map(btn => {
            if (btn.componentOptions && btn.componentOptions.propsData) btn.componentOptions.propsData.type = 'text'

            return h(DropdownItem, {class: 'pagoda-collapse-button-dropdown'}, [btn])
          }))
        ]) : null
      ])
    },
    methods: {
      getButtons (slots) {
        return slots.filter(({tag, text}) => tag || !!text.trim())
      },
      getCollapseControl (h) {
        return h('div', {
          class: 'pagoda-collapse-button__controller'
        }, [this.$slots['collapse-controller'] || h(Button, {
          props: {
            type: 'primary',
            plain: false
          }
        }, [
          '更多条件',
          h('i', {class: 'el-icon-arrow-down el-icon--right'})
        ])])
      }
    }
  }
</script>